export default function customiz() {
  
  (function($){
    /////////////////////////////////////////////////////////////////////////////////////////////
    // Afichage des téléphones
    $(".js-phone-reveal").on("click", function () {
      $(this).find("span").text($(this).data("number"));
    });

    //annuler bouton tel sauf sur mobile
    /*jshint scripturl:true*/
    var $window = $(window);

    function checkWidth() {
      var windowsize = $window.width();
      if (windowsize > 767) {
        $(".js-phone-reveal").attr("href", "javascript:void(0)");
      }
    }

    // Execute on load
    checkWidth();

    ///////////////////////////////
    // activation totop
    ///////////////////////////////
    var offset = 300,
      offset_opacity = 1200,
      scroll_top_duration = 700,
      $back_to_top = $(".totop");

    //hide or show the "back to top" link
    $(window).on("scroll", function () {
      $(this).scrollTop() > offset
        ? $back_to_top.addClass("cd-is-visible")
        : $back_to_top.removeClass("cd-is-visible cd-fade-out");
      if ($(this).scrollTop() > offset_opacity) {
        $back_to_top.addClass("cd-fade-out");
      }
    });

    //smooth scroll to top
    $back_to_top.on("click", function (event) {
      $("body,html").animate(
        {
          scrollTop: 0,
        },
        scroll_top_duration
      );
    });

    ///////////////////////////////
    // Menu mobile
    ///////////////////////////////

    $(document).on("click", ".js-open-menu", function () {
      $(".js-slide-menu").addClass("active");
      $("body").addClass("menu-is-open");
    });

    $(document).on("click", ".js-close-menu", function () {
      $(".js-slide-menu").removeClass("active");
      $("body").removeClass("menu-is-open");
    });

    var ElementWithChild = $('.slide-menu .menu-item-has-children');
    ElementWithChild.each(function () {
      var Parent = $(this).find('.has-children-wrapper a, .has-children-wrapper p').text();
      $(this).children('.sub-menu').prepend(
        '<li class="menu-item"><a class="go-parent nav-link js-return-parent">' + Parent + '</a></li>'
      );
    });

    $(".js-mobile-menu").on( 'click',function () {
      $(".js-slide-menu").addClass("active");
      $(".js-close-slide").addClass("active");
      $("body").addClass("menu-is-open");
    });

    $(".js-close-slide").on('click',function () {
      $("body").removeClass("menu-is-open");
      $(".js-slide-menu").removeClass("active");
      $(".js-close-slide").removeClass("active");
    });

    $(".js-open-sub-menu").on('click',function (e) {
      e.preventDefault();
      var sub = $(this).parent().parent().find(".sub-menu:first");
      sub.addClass("active");
    });

    $(".js-return-parent").on('click',function () {
      $(this).parent().parent().removeClass("active");
    });

    
    ////////////////////////////////////
    // Copy current URL to clipboard
    // Au clic sur ".js-copy-to-clipboard"
    ///////////////////////////////////
    var $inputTemp = $("<input>");
    var $url = $(location).attr('href');

    $('.js-copy-to-clipboard').on('click', function() {
      $("body").append($inputTemp);
      $inputTemp.val($url).select();
      document.execCommand("copy");
      $inputTemp.remove();
      //console.log('url copié');
    })

    ///////////////////////////////
    // Is in view ?
    ///////////////////////////////
    var elementInView = $(".js-in-view");
    $(document).ready(function () {
      $.each(elementInView, function (i, element) {
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        if (elementBottom > viewportTop && elementTop < viewportBottom) {
          if (!$(element).hasClass("visible")) {
            $(element).addClass("visible");
          }
        }else{
            $(element).addClass("invisible");
          }
      });
    });
    $(window).on("scroll", function () {
      $.each(elementInView, function (i, element) {
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        if (elementBottom > viewportTop && elementTop < viewportBottom) {
          if (!$(element).hasClass("in-view")) {
            $(element).addClass("in-view");
            $(element).removeClass("invisible");
          }
        }
      });
    });


    //debug iframe youtube dans article
    function responsiveIframe() {
      var container = $(".article__content");
      var iframe = $("iframe:not(.srhJobsBoardContainer)", container);
      iframe.each(function () {
        $(this).wrap(
          "<span class='ratio ratio-16x9'></span>"
        );
        $(this).addClass("embed-responsive-item");
      });
    }
    responsiveIframe();


    /***
     *
     * Obfuscation des liens
     * 
    ***/

      $('.js-obf-link').on('click', function(){
        var dest = $(this).data('link');
        var target = $(this).data('target');
        var decodeDest  = atob(dest);
        
        if(target == '_blank'){
          window.open(decodeDest, '_blank');
        }else{
          window.location.href = decodeDest;
        }

      });


    })(jQuery);
    }
